export { BaseEntity } from './BaseEntity';
export { BaseService } from './BaseService';
